import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap comic-panel nft-holder" }
const _hoisted_2 = { class: "text top-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestNFTCard = _resolveComponent("QuestNFTCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nfts, (nft) => {
        return (_openBlock(), _createElementBlock("div", null, [
          (nft.onchainMetadata.updateAuthority == 'AVwojGPy3CpGj3Etv2f4ekFtQbppLfgppNSFQnxMVneV')
            ? (_openBlock(), _createBlock(_component_QuestNFTCard, {
                key: nft,
                nft: nft,
                vault: _ctx.vault,
                farmerAcc: _ctx.farmerAcc,
                onSelected: _ctx.handleSelected
              }, null, 8, ["nft", "vault", "farmerAcc", "onSelected"]))
            : _createCommentVNode("", true)
        ]))
      }), 256))
    ])
  ]))
}